import React from 'react';

import { Paper, Stack, Typography } from '@mui/material';

interface Props {
  children: React.ReactNode;
  title: string;
}

export default function InfoCard({ title, children }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2, overflow: 'hidden' }}>
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="overline" color="text.secondary">
            {title}
          </Typography>
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
}
